# Theme variables injected by gulp
THEME_NAME = 'bogen'
angular.module('app.controllers').controller 'ProgramsCtrl', [
  '$scope', '$rootScope', 'APIPrograms', 'Table', 'APIProgramsTable', '$cookies'
].append (self, root, APIPrograms, Table, APIProgramsTable, $cookies) ->

  tableName   = 'c.pro.' + (root.user?.shortcode || 'page')
  cookiesName = 't.' + tableName

  #
  # Search dropdown functionality
  #

  self.term = ""

  searchParams =
    search: self.term
    page: 1
    limit: 10

  self.sugg = Table
    name: tableName + ".sugg"
    type: "partial"
    resource: APIProgramsTable
    cookies: true
    params: searchParams

  self.onSearchTermChange = () ->
    self.sugg.params.search = self.term

  self.initSearchDropdown = () ->
    searchInput = document.getElementById('searchInput')
    searchDropdown = document.getElementById('searchDropdown')

    return unless searchInput and searchDropdown

    # Show dropdown when input is focused (including tab navigation)
    searchInput.addEventListener 'focus', () ->
      # Don't show dropdown if input has ng-invalid class
      unless searchInput.classList.contains 'ng-invalid'
        searchDropdown.classList.add 'show'

    # Hide dropdown when input loses focus (including tab navigation)
    searchInput.addEventListener 'blur', () ->
      # Small delay to allow clicking on dropdown items
      setTimeout () ->
        unless searchDropdown.contains document.activeElement
          searchDropdown.classList.remove 'show'
      , 100

    # Prevent dropdown from closing when clicking inside the input
    searchInput.addEventListener 'click', (e) ->
      e.stopPropagation()
      # Don't show dropdown if input has ng-invalid class
      unless searchInput.classList.contains 'ng-invalid'
        searchDropdown.classList.add 'show'

    # Prevent dropdown from closing when clicking inside the dropdown menu
    searchDropdown.addEventListener 'click', (e) ->
      e.stopPropagation()

    # Close dropdown when clicking outside
    document.addEventListener 'click', (e) ->
      unless searchInput.contains(e.target) or searchDropdown.contains(e.target)
        searchDropdown.classList.remove 'show'

    # Close dropdown when pressing Escape key
    searchInput.addEventListener 'keydown', (e) ->
      if e.key is 'Escape'
        searchDropdown.classList.remove 'show'
        searchInput.blur()

  self.closeDropdown = () ->
    self.term = ""
    self.onSearchTermChange()
    searchDropdown.classList.remove 'show'
    searchInput.blur()

  # Watch term changes and control dropdown visibility based on ng-invalid class
  self.$watch 'term', (newValue, oldValue) ->
    searchInput = document.getElementById('searchInput')
    searchDropdown = document.getElementById('searchDropdown')

    return unless searchInput and searchDropdown

    if searchInput.classList.contains 'ng-invalid'
      searchDropdown.classList.remove 'show'
    else if newValue and newValue.trim() and searchInput == document.activeElement
      searchDropdown.classList.add 'show'

  # Initialize dropdown when controller is ready
  self.initSearchDropdown()


  self.speaker = null

  self.speakerModalEl = document.getElementById('speakerModal')

  if self.speakerModalEl
    self.speakerModal = bootstrap.Modal.getOrCreateInstance(self.speakerModalEl)

    self.speakerModalEl.addEventListener('show.bs.modal', (event) ->
      self.$applyAsync()
    )

    self.speakerModalEl.addEventListener('hidden.bs.modal', (event) ->
      self.speaker = null
      self.$applyAsync()
    )

  self.openSpeakerModal = (speaker) ->
    self.speaker = speaker
    return self.speakerModal?.show()
